import { AVAILABLE_FONTS } from './fontRegistry';

// 数据库配置
const DB_NAME = 'FontsDatabase';
const DB_VERSION = 1;
const FONT_STORE = 'fonts';

// 创建和初始化数据库
export const initFontDatabase = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    
    request.onerror = (event) => {
      console.error('IndexedDB error:', event.target.error);
      reject(event.target.error);
    };
    
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      // 创建字体存储对象
      if (!db.objectStoreNames.contains(FONT_STORE)) {
        const store = db.createObjectStore(FONT_STORE, { keyPath: 'id' });
        store.createIndex('family', 'family', { unique: false });
        store.createIndex('style', 'style', { unique: false });
        store.createIndex('weight', 'weight', { unique: false });
      }
    };
    
    request.onsuccess = (event) => {
      const db = event.target.result;
      resolve(db);
    };
  });
};

// 存储字体数据到IndexedDB
export const storeFontData = async (fontId, fontFamily, fontStyle, fontWeight, fontData) => {
  try {
    const db = await initFontDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([FONT_STORE], 'readwrite');
      const store = transaction.objectStore(FONT_STORE);
      
      const fontRecord = {
        id: fontId,
        family: fontFamily,
        style: fontStyle,
        weight: fontWeight,
        data: fontData,
        timestamp: Date.now()
      };
      
      const request = store.put(fontRecord);
      
      request.onsuccess = () => resolve(true);
      request.onerror = (event) => {
        console.error('Error storing font:', event.target.error);
        reject(event.target.error);
      };
    });
  } catch (error) {
    console.error('Failed to store font data:', error);
    return false;
  }
};

// 从IndexedDB获取字体数据
export const getFontData = async (fontId) => {
  try {
    const db = await initFontDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([FONT_STORE], 'readonly');
      const store = transaction.objectStore(FONT_STORE);
      const request = store.get(fontId);
      
      request.onsuccess = (event) => {
        const result = event.target.result;
        resolve(result ? result.data : null);
      };
      
      request.onerror = (event) => {
        console.error('Error retrieving font:', event.target.error);
        reject(event.target.error);
      };
    });
  } catch (error) {
    console.error('Failed to get font data:', error);
    return null;
  }
};

// 检查字体是否已缓存
export const isFontCached = async (fontId) => {
  try {
    const fontData = await getFontData(fontId);
    return fontData !== null;
  } catch (error) {
    console.error('Failed to check font cache:', error);
    return false;
  }
};

// 获取所有需要加载的字体列表
export const getAllFontIds = () => {
  const fontIds = [];
  
  Object.entries(AVAILABLE_FONTS).forEach(([fontKey, fontConfig]) => {
    if (fontConfig.styles) {
      Object.entries(fontConfig.styles).forEach(([styleKey, styleConfig]) => {
        if (styleConfig.src && !styleConfig.src.startsWith('data:')) {
          const fontId = `${fontKey}_${styleKey}`;
          // 确保字体路径是绝对路径
          let fontSrc = styleConfig.src;
          if (fontSrc.startsWith('/')) {
            fontSrc = fontSrc.substring(1); // 移除开头的斜杠
          }
          // 添加公共路径前缀
          fontSrc = `${process.env.PUBLIC_URL || ''}/${fontSrc}`;
          
          fontIds.push({
            id: fontId,
            family: fontConfig.family,
            src: fontSrc,
            weight: styleConfig.weight || 'normal',
            style: styleConfig.style || 'normal'
          });
        }
      });
    }
  });
  
  console.log('Font IDs to load:', fontIds);
  return fontIds;
};

// 清除字体缓存
export const clearFontCache = async () => {
  try {
    const db = await initFontDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([FONT_STORE], 'readwrite');
      const store = transaction.objectStore(FONT_STORE);
      const request = store.clear();
      
      request.onsuccess = () => resolve(true);
      request.onerror = (event) => {
        console.error('Error clearing font cache:', event.target.error);
        reject(event.target.error);
      };
    });
  } catch (error) {
    console.error('Failed to clear font cache:', error);
    return false;
  }
};